<template>
	<a
		:aria-disabled="isLoaded"
		id="loginClaveTributaria"
		class="btn-center btn-cu btn-l btn-fw bt_ctrib"
		@click="signInClaveTributaria"
	>
		<img :src="claveTributariaTxt"/>
	</a>
</template>

<script>

import claveTributariaTxt from '@/assets/logo_ct.png'
import providersMixins from './providersMixins';

export default {
	mixins: [providersMixins],
	computed:{
	},
	data () {
		return {
			claveTributariaTxt: claveTributariaTxt
		};
	},
	methods:{
		async signInClaveTributaria(){

			window.location.replace(this.urlSignIn)
		}
	},
	mounted(){
		this.signInClaveTributaria()
	}
}


</script>

<style>

	.btn-center {
		margin: auto;
	}

/* Boton estilo de base */
	.btn-cu {
		display: inline-block;
		font-family: Roboto, sans-serif;
		font-weight: 400;
		text-align: center;
		vertical-align: middle;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		border-radius: 0;
		height: 100%;
	}

	/* Boton estilo con isotipo */
	.cl-claveunica-logo {
		display: inline-block;
		font-family: Roboto, sans-serif;
		font-weight: 400;
		text-align: center;
		vertical-align: middle;
	}

	/* Tamaño M */
	.btn-cu.btn-m {
		width: 160px;
		min-width: 160px;
		max-height: 42px;
		padding: 8px 18px 8px 15px !important;
		font-size: 16px;
		line-height: 1.6em;
	}
	.btn-cu.btn-m .cl-claveunica {
		display: inline-block;
		width: 24px;
		height: 24px;
		background-size: 24px 24px;
	}

	/*Icono ClaveÚnica*/
	.btn-cu .cl-claveunica {
		display: inline;
		float: left;
		text-indent: -9999px;
	}
	/*Texto ClaveÚnica*/
	.btn-cu .texto {
		padding-left: 3px;
		text-decoration: underline;
	}

	.btn-cu.btn-fw {
		max-width: 550px;
		width: 100%;
		display: flex;
		justify-content: center;
	}

	.btn-cu.btn-color-estandar {
		background-color: #0F69C4;
		color: #FFF;
	}

	.btn-cu.btn-color-estandar:hover {
		background-color: #0C549C;
		color: #FFF;
	}

	.btn-cu.btn-color-estandar:active {
		background-color: #093F75;
		color: #FFF;
	}

	.btn-cu.btn-color-estandar:focus {
		background-color: #0C549C;
		color: #FFF;
		outline: 1px dashed #000;
	}

	/* Tamaño L */
	.btn-cu.btn-l {
		/* width: 180px; */
		min-width: 180px;
		/* max-height: 48px; */
		padding: 11px 18px !important;
		font-size: 18px;
	}

	.btn-cu.btn-l .cl-claveunica {
		width: 26px;
		height: 26px;
		background-size: 26px 26px;
	}

	.bt_ctrib{
    text-transform: uppercase;
    font-weight: bold;
    font-size: 14px;
    margin: 0px auto 10px;
    background-color: #002c48;
    border: none;
    display: block;
    width: 100%;
    padding: 8px;
    border-radius: 0px;
    color: #fff;
    height: 60px;
	}

	.bt_ctrib:active, .bt_cunica:active{
		opacity: .8;
	}
</style>